(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section-related"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('[data-related-products]').forEach((container) => {
      const slider = container.querySelector('.swiper-product');
      if (!slider || slider.dataset.swiperInitialized === 'true') return;

      slider.dataset.swiperInitialized = 'true';

      const relSlideCount = slider.querySelectorAll('.swiper-slide').length;

      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 24,
        loop: true,
        pagination: {
          el: container.querySelector('.swiper-pagination'),
          clickable: true,
          // 08.09.2026: УНІФІКОВАНО - завжди крапки (еталон = слайдер Artist Packs)
          type: 'bullets',
        },
        navigation: {
          nextEl: container.querySelector('.swiper-button-next'),
          prevEl: container.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          1000: { slidesPerView: 3 },
          768: { slidesPerView: 2 },
          480: { slidesPerView: 1 },
        },
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
